import { pageInfo, toxinInspectSetVehicleSave} from './../api';
import { Message } from 'element-ui';
const toxinInspectVehicleArragement = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    updateResp: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    UPDATE_DATA(state, data){
      state.updateResp = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //毒素检查结果提交
    async toxinInspectSetVehicleSave({ commit }, obj) {
      let resp = await toxinInspectSetVehicleSave(obj);
      commit('UPDATE_DATA', resp);
    },
  }
}
export default toxinInspectVehicleArragement



// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectVehicleArragement/store/toxinInspectVehicleArragement.store.js